import { DocumentList } from 'api/Documents/types';

const documentsUrl = 'documents/';
const documentsListUrl = (list: DocumentList) => `${documentsUrl}?list=${list}`;

export default { documentsListUrl };
